import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChevronTriangleLeftMedium"><Path d="M12.6068 8.13028C13.2574 7.58378 14.25 8.04631 14.25 8.89599V15.104C14.25 15.9537 13.2574 16.4162 12.6068 15.8697L8.91155 12.7657C8.43581 12.3661 8.43581 11.6339 8.91155 11.2343L12.6068 8.13028Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChevronTriangleLeftMedium;
